<div class="fmnts-card-header-content">
  <ng-content
    select="fmnts-card-subtitle,fmnts-card-title,[fmnts-card-header-content]"
  ></ng-content>
</div>
<ng-content></ng-content>
